<template>
  <div id="app" ref="app">
	  <!-- 111 -->
    <!-- <router-view to="/index"/> -->
	<Index v-if="$pc"></Index>
	<mIndex v-if="!$pc"></mIndex>
  </div>
</template>
<script>
export default {
  name: 'App',
  onLaunch: function () {
    console.log("App Launch");
  },
  onShow: function () {
    console.log(this);
  },
  onHide: function () {
    console.log("App Hide");
  },
  components: {
  	// ../../components/NavBar
  	Index: () => import('./views/index.vue'),
	mIndex: () => import('./views/mobile/index.vue'),
  },
  watch:{
	  $pc(){
		  // this.$router.go(0)
	  }
  },
  // mounted() {
		// if(!this.$pc){
		// 	if(this.$route.path == '/m_index') return;
		// 	this.$router.replace({
		// 		path: '/m_index'
		// 	});
		// }else{
		// 	if(this.$route.path == '/index') return;
		// 	this.$router.replace({
		// 		path: '/index'
		// 	});
		// }
  // },
    created() {
		var that = this;
		that.resize();
	},
	mounted() {
		const that = this;
		window.onresize = that.resize;
	},
	methods: {
		goBack() {
		  this.$router.replace("/index"); // 这里写上你要跳转的页面
		},
		resize: function() {
			// console.log(this.$pc)
			
			if(!this.$pc){
				if(this.$route.path == '/m_index') return;
				this.$router.replace({
					path: '/m_index'
				});
			}else{
				if(this.$route.path == '/index') return;
				this.$router.replace({
					path: '/index'
				});
			}
		},
    },
};
</script>

<style>
	#app {
		height: 100%;
	}
</style>